// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"66c26dc6","455":"10ca02bc","977":"edf04541"}[chunkId] + ".chunk.js";
};